<!-- Video Modal -->
<div class="modal-content">
    <div class="modal-body">
        <div class="fc_modal_body">
            <button type="button" class="btn-close" (click)="activeModel.close()" aria-label="Close the popup"></button>
            <h3 class="h3">{{ modules?.name }}</h3>
            <div class="guide_video_box p-0">
                <div class="guide_video ratio ratio-16x9">
                    <iframe width="560" height="315" [src]="url"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen title="Vault">
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</div>